/**
 * Route for `performance-tier-badges-for-affiliates`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { PerformanceTierBadgesForAffiliatesPage } from "../features/performance-tier-badges-for-affiliates/PerformanceTierBadgesForAffiliatesPage";

export const performanceTierBadgesForAffiliatesRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/performance-tier-badges-for-affiliates",
	component: PerformanceTierBadgesForAffiliatesPage,
});

export default performanceTierBadgesForAffiliatesRoute;
